import Routes from './Routes'
import '../i18n'
import { useEffect } from 'react'
import { LANG } from '../constants'
import { useTranslation } from 'react-i18next'

export default function App() {
  const { i18n } = useTranslation()
  useEffect(() => {
    const storedLang : string | null | undefined = localStorage.getItem(LANG.STORAGE_NAME)
    let defaultLang = storedLang ? storedLang : 'en'
    
    i18n.changeLanguage(defaultLang)
  }, [])

  return (
    <div className="App">
      <Routes></Routes>
    </div>
  );
}
